<div class="map-section">
    <div id="map" class="map"></div>
    @if (legendsList && legendsList.length > 0) {
        <div id="legend" class="map-legend">
            @if (hasNoDevice) {
                <div class="no-loc">
                    <img src="assets/icons/map-icons/no-model.svg" alt="no-model-icon" />
                    <span> 0 Device </span>
                </div>
            } @else {
                @if (noLocationCount > 0) {
                    <div class="no-loc">
                        <img src="assets/icons/map-icons/no-location.svg" alt="Map Icon" />
                        <span class="me-1">{{ noLocationCount }}</span>
                        <span>No location Configured</span>
                    </div>
                }
                @for (legend of legendsList; track legend) {
                    <div class="legend-item">
                        <img [src]="legend.icon" alt="Map Icon" />
                        @if (!legend.modelName) {
                            <span class="me-1">{{ legend.count }}</span>
                            <span>No Model Configured</span>
                        } @else {
                            <span class="me-1">{{ legend.count }}</span>
                            <span class="me-1">{{ legend.modelName }}</span>
                            <span>{{ legend.deviceStatus ? 'Online' : 'Offline' }}</span>
                        }
                    </div>
                }
            }
        </div>
    }
    <div id="popup" class="ol-popup">
        <a href="javascript:void(0)" id="popup-closer" class="ol-popup-closer"></a>
        <div id="popup-content" class="ol-popup-text-sec"></div>
    </div>
</div>
